import React from 'react'
import _ from 'lodash'
import ViewBreakPoints from './ViewBreakPoints'

const RootClass = 'ap-reservation-gantt'

const SecondaryHeaders = ({headers, onClick}) => {
  return (
    <div className="ap-reservation-gantt__date-row">
      {_.map(headers, (e, i) => (
        <div
          key={i}
          style={{
            flex: `0 0 ${e.colSpan * e.width}px`,
            width: e.colSpan * e.width,
            borderLeft: 'none',
            position: 'sticky',
            backgroundColor: '#fff',
            pointerEvents: 'none',
          }}
          className="ap-reservation-gantt__column-head"
          onClick={ev => onClick(ev, e)}
        >
          <div className={`${RootClass}__head-label`}>
            <span className={`${RootClass}__head-title-2`}>{e.label}</span>{' '}
            <span className={`${RootClass}__head-title-2-sub`}>{e.label_sub}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SecondaryHeaders
